import { Component, OnInit } from '@angular/core';

import { EnvironmentService } from '@library/core/services';

import { NavMenuService, NavItem } from '@library/modules/menu';
import { ScheduleReportService } from '@library/modules/reports/schedule-report/schedule-report.service';
import { UseraccessService } from '@library/modules/user';
import { first, forkJoin } from 'rxjs';

const MenuItems: NavItem[] = [
   // { label: 'Manage',       path: '/manage',    icon: 'shipments' },
   // { label: 'Create',       path: '/create',    icon: 'createshipment' },
   // { label: 'Create Shipment', path: '/shipment',     icon: 'createshipment', access: 'booking'   },
   { label: 'Templates',       path: '/template',     icon: 'templates',      access: 'booking'   },
   { label: 'Invoices',        path: '/invoice',      icon: 'invoices',       access: 'invoicing' },
   { label: 'Reports',         path: '/report',       icon: 'reports',        access: 'tracking'  },
   { label: 'Activity Feed',   path: '/activityfeed', icon: 'activityfeed',   access: 'tracking'  },
   { label: 'Address Book',    path: '/addressbook',  icon: 'addressbook',    access: 'booking'   },
   // { label: 'Admin',           path: '/admin',        icon: 'admin',          access: 'admin' },
];

@Component({
   selector: 'app-menu',
   templateUrl: './menu.component.html',
   styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

   private menus: NavItem[] = MenuItems;

   public loaded: boolean = false;

   constructor(
      private nav: NavMenuService,
      private scheduleReportService: ScheduleReportService,
      private access: UseraccessService,
      
      public environment: EnvironmentService,
   ) {
      
   }

   ngOnInit(): void {
      forkJoin([
         this.access.hasAccess('quoting').pipe(first()),
         this.access.hasAccess('tracking').pipe(first()),
         this.access.hasAccess('booking').pipe(first()),
      ])
      .subscribe(([ quote, track, booking ]) => {
         this.menus = [];

         // for the listing
         if ( quote && track ) {
            this.menus.push({ label: 'Manage',       path: '/manage',    icon: 'shipments' });
         } else if ( quote ) {
            this.menus.push({ label: 'Quotations',       path: '/manage',    icon: 'shipments' });
         } else if ( track ) {
            this.menus.push({ label: 'Shipments',       path: '/manage',    icon: 'shipments' });
         }

         // For the create
         if ( quote && booking ) {
            this.menus.push({ label: 'Create',       path: '/create',    icon: 'createshipment' });
         } else if ( quote ) {
            this.menus.push({ label: 'Create Quotation',       path: '/create',    icon: 'createshipment' });
         } else if ( booking ) {
            this.menus.push({ label: 'Create Shipments',       path: '/create',    icon: 'createshipment' });
         }

         this.menus.push( ...MenuItems );

         this.loaded = true;

         this.nav.load( this.menus, this.scheduleReportService );
         this.nav.showTracking = true;
         this.nav.title = 'customer portal';
      });
   }
}
